var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHideMap2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132 117.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2125257098032"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.3,93.2c-3,0-4.6-1.4-5.8-1.7,.3-1.1,10.7-11,11.9-12.3,1.1-1.1,3.1-3.3,4.1-4,2.3,4.3,2.5,7.9,0,12.3-1.7,3.2-5.5,5.7-10.4,5.7h0Zm-29.3,14.6l3.4,3.5,11.6-11.5c7.2,3.7,17.1,3.8,25.1,1.5,5.5-1.6,12-5.6,15.9-9.8,1.9-2,7.7-8.6,7-10.5-.2-.5-.7-1.3-1-1.7l-2.1-3.1c-2.8-3.9-5.5-6.2-9.2-9-.6-.4-.9-.8-1.6-1,.4-1.5,9.3-9.2,10.6-11l-3.4-3.3-56.2,56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.8,94.6l10.5-10.6c2.3-2.2-1.3-3.9,3.5-10.1l2.4-2.2c.5-.3,1.5-.8,2.1-1.1,1.5-.7,4.1-1.2,6.2-.7,1.1-1.6,7.6-7.1,7.9-8.4-2.4-.6-4.6-1.1-7.2-1.2-1.2,0-1.4-.3-2.6-.3l-5.1,.5c-4.8,.8-8.5,2-12.7,4.4l-5,3.4c-2.5,2-5.1,4.6-7,7.2-1.4,1.9-4.4,5.3-3.5,7,.3,.6,.7,1.1,1,1.6,2.1,3.3,6.4,8.5,9.4,10.5h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,15.6V115.9c0,.6,.6,1,1.3,1.4,.7,.4-.5,.3,.9,.3s4.3-1.2,5.3-1.5l15.7-5.2c2.4-.8,20-6.8,20.8-6.8s7.1,3,8.1,3.4c4.2,1.7,10.4,5.5,10.4,.7s-1.9-2.2-3.2-2.8c-3.5-1.6-10.1-4.2-12.9-5.6V6.2c.6,.1,3.5,1.7,4.3,2.2l21.3,11.4c.7,.4,1.3,.7,2.1,1,1.4,.7,5.6,3.2,6.6,3.4v22.3c0,1.7,.3,2.5,.2,4.3,0,1.4-.4,5.4,.4,6.3,1.5,1.7,4.1,.7,4.4-1.1V24.5s32-13.1,32-13.1c.7-.3,1.7-.7,2.3-.8V46.6c0,1.8-.1,1.7,1.9,1.7s2.9-.9,2.9-1.9V6.2c0-.7-1.4-1.7-1.9-1.7-1.3,0-4,1.4-5.4,1.8-8.5,3-21.6,8.9-30.7,12.5-5,2-2.1,1.9-9.6-1.8L53.6,4.7c-1.4-.8-8.6-4.7-9.9-4.7s-4.7,1.4-5.6,1.6L4.7,12.9c-1.2,.5-4.7,1.4-4.7,2.7H0ZM4.9,111.9l36.4-12.1-.2-94.3L4.7,17.6l.2,94.3h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideMap2);
export default __webpack_public_path__ + "static/media/HideMap2.e29b7145b271ab533121e8857bc9ad12.svg";
export { ForwardRef as ReactComponent };